import { TFunction } from 'react-i18next'
import * as yup from 'yup'
import { LOCAL_USD_ACCOUNT_NUMBER_MIN_LENGTH } from 'pages/ManageBeneficiaries/AddBeneficiary/components/schemas/fields/usdSpecificFields'
import { ALPHANUMERIC_VALIDATION } from './createNameSchema'

const IBAN_MIN_LENGTH = 11
const IBAN_MAX_LENGTH = 40
const IBAN_CURRENCIES = ['EUR', 'GBP']
export const IBAN_ALPHANUMERIC_REQUIRED_VALIDATION = /^(?=.*[0-9])(?=.*[a-zA-Z])[0-9a-zA-Z]+$/

export const createIbanSchema = (t: TFunction<'translation', undefined>) => {
  return yup
    .string()
    .trim()
    .label(t('iban'))
    .test({
      test(value, ctx) {
        if (value?.length < IBAN_MIN_LENGTH || value?.length > IBAN_MAX_LENGTH) {
          return ctx.createError({
            message: t('ibanFormatError'),
          })
        }

        if (!ALPHANUMERIC_VALIDATION.test(value)) {
          return ctx.createError({
            message: t('ibanFormatError'),
          })
        }

        return true
      },
    })
}

export const createSwiftAccountNumberSchema = (t: TFunction<'translation', undefined>) => {
  return yup
    .string()
    .trim()
    .test({
      test(value, ctx) {
        const isUsd = ctx?.parent?.currencyCode === 'USD'
        const isIbanValidationRequired = IBAN_CURRENCIES.includes(ctx?.parent?.currencyCode)

        // If USD, then simply check for min and max length, as this can be an account number or IBAN
        if (isUsd) {
          if (
            value?.length < LOCAL_USD_ACCOUNT_NUMBER_MIN_LENGTH ||
            value?.length > IBAN_MAX_LENGTH
          ) {
            return ctx.createError({
              message: t('usdAccountNumberOrIbanFormatError'),
            })
          }

          if (!ALPHANUMERIC_VALIDATION.test(value)) {
            return ctx.createError({
              message: t('fieldAlphanumeric', {
                field: t('accountNumber'),
                interpolation: { escapeValue: false },
              }),
            })
          }

          return true
        }

        // IF EUR or GBP, then account number should be a valid IBAN
        if (isIbanValidationRequired) {
          if (value?.length < IBAN_MIN_LENGTH || value?.length > IBAN_MAX_LENGTH) {
            return ctx.createError({
              message: t('ibanFormatError'),
            })
          }

          if (!ALPHANUMERIC_VALIDATION.test(value)) {
            return ctx.createError({
              message: t('ibanFormatError'),
            })
          }
          return true
        }

        return true
      },
    })
}
